import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/member/AEmailSettings/index",{
        params: {
            page:params
        }
    } )
}

function SUBMIT_ADD(params) {
    return axios.post("/member/AEmailSettings/addPost",{...params} )
}
function GET_FORMDATA(params) {
    return axios.post("/member/AEmailSettings/add",{...params} )
}
function GET_EDIT_FORM(params) {
    return  axios.get("/member/AEmailSettings/edit",{
        params: {
            id:params
        }
    } )
}
function SUBMIT_EDIT (params) {
    return axios.post("/member/AEmailSettings/editPost",{...params} )
}
function DELE(params) {
    return  axios.get("/member/AEmailSettings/delete",{
        params: {
            ids:params
        }
    } )
}

function CHANG_STATUS (params) {
    return  axios.post("/member/AEmailSettings/statusEdit",{status:params} )
}
export default {
    GET_LIST,
    SUBMIT_ADD,
    GET_FORMDATA,
    GET_EDIT_FORM,
    SUBMIT_EDIT,
    DELE,
    CHANG_STATUS

};